<template>
    <BCard >
        <ValidationObserver ref="form" #default="{invalid}">
            <BForm @submit.prevent="onSubmit">
                <BRow>
                    <vSelectValidated vsName="Student"  :vsModel.sync="enrollment.student" :vsOptions="students" vsLabel="search_name" vsMd="6" vsRequired vsRules="required" @vsOnSearch="changedStudentsQuery" />
                    <vSelectValidated vsName="Course" :vsModel.sync="enrollment.course" :vsOptions="courses" vsLabel="search_name" vsMd="6"  vsRequired vsRules="required" @vsOnInput="changedCourse" @vsOnSearch="changedCoursesQuery"/>
                    <DatepickerValidated vsName="Start date" :vsModel.sync="enrollment.start_date" vsMd="6" vsRequired vsRules="required" :vsMin="enrollment.course ? minDateEnrollment : ''" @vsOnInput="changedCourse" />
                    <vSelectValidated vsName="Sucursal" :vsDisabled="(enrollment.course && enrollment.course.group_id) ? true : false" vsRequired vsRules="required" :vsModel.sync="enrollment.group_id" :vsOptions="groups" :vsReduce="gr=>gr.id" vsLabel="name" vsMd="6" v-if="groups && groups.length>1"/>

                    <BCol cols="12" v-if="cursoMensual"><p>Curso de pago mensual:</p></BCol>
                    <div class="w-100"></div>

                    <BCol cols="12"><div v-if="cursoMensual">* Si no cubres los siguientes campos, se cobrarán los importes por defecto del curso</div></BCol>
                    <NumberInputValidated v-if="cursoMensual"  vsName="Mensualidad estándar para este alumno/a (opcional)"  vsMd="6" :vsModel.sync="enrollment.monthly_payment"/>
                    <NumberInputValidated v-if="cursoMensual"  vsName="Pago primer mes para este alumno/a (opcional)"  vsMd="6" :vsModel.sync="enrollment.first_month_payment"/>
                    <!-- <NumberInputValidated v-if="cursoMensual" :vsDisabled="true" vsName="Pago último mes"  vsMd="6"  :vsModel.sync="enrollment.last_month_payment"/>  -->
                    
                    <BCol cols="12" v-if="!cursoMensual && enrollment.course && termsToPay.length>0"><p>Curso de pago a plazos. Plazos a pagar:</p></BCol>
                    
                    <BCol>
                        <div v-for="(term, index) in termsToPay" :key="index" class="border rounded p-1 mb-1">
                            <BCol cols="12"> 
                                <BRow> 
                                    <BCol> 
                                        <p>Plazo {{ index+1 }}</p> 
                                    </BCol> 
                                </BRow>
                            </BCol>

                            <BCol>
                                <BRow>
                                    <DatepickerValidated vsName="Start date" :vsDisabled="true" :vsModel.sync="term.start_date" vsMd="6" vsRequired vsRules="required" />
                                    <NumberInputValidated vsName="Amount" :vsDisabled="true" :vsModel.sync="term.term_payment" vsMd="6" vsRequired vsRules="required"/>
                                </BRow>
                            </BCol>
                        </div>
                     </BCol>
                    
                    </BRow>
                    
                    <BRow class="mt-2 align-items-center">
                        <CheckboxValidated  vsName="make_invoice" vsLabel="Generate invoice" :vsModel.sync="enrollment.make_invoice" />
                        <hr class="invoice-spacing">
                        <vSelectValidated v-if="enrollment.make_invoice" vsName="Método de pago" vsRequired vsRules="required" :vsModel.sync="invoice.payment_method" :vsReduce="pay => pay.name" :vsOptions="paymentMethodsOptions"  vsLabel="name" vsMd="6" />
                        <BCol md="1">
                            <BFormCheckbox v-if="enrollment.make_invoice" v-model="invoice.paid"> Pagada </BFormCheckbox>
                        </BCol>

                        <vSelectValidated v-if="invoice.payment_method && invoice.payment_method=='Efectivo' && invoice.paid && enrollment.make_invoice" vsName="Caja" vsRequired vsRules="required" :vsModel.sync="enrollment.cash_id" :vsOptions="cashesOptions" :vsReduce="cash=>cash.id" vsLabel="name" vsMd="4" />
                        <TextInputValidated vsMd="3" v-if="(invoice.payment_method=='Domiciliaciones de pago' || invoice.payment_method=='Transferencias bancarias') && enrollment.make_invoice" :vsModel.sync="invoice.bank_account_iban" vsName="Cuenta bancaria"  vsLabel="bank_account" :vsDisabled="true" vsRequired vsRules="required" />

                        <TextInputValidated vsMd="2" v-if="(invoice.payment_method=='Domiciliaciones de pago' || invoice.payment_method=='Transferencias bancarias') && enrollment.make_invoice" :vsModel.sync="invoice.bank_account_swift" vsName="SWIFT/BIC"  vsLabel="bank_account" :vsDisabled="true" vsRequired vsRules="required" />
                        

                    </BRow>

                    <BRow>
                        <BCol md="4" class="">
                            <div class="price-details border p-1 py-2 rounded" v-if="enrollment.make_invoice">
                                <h6 class="price-title">
                                    {{ $t('Paying details') }}
                                </h6>
                                <ul class="list-unstyled">
                                    <li class="price-detail d-flex justify-content-between">
                                    <div class="detail-title">
                                        Subtotal
                                    </div>
                                    <div class="detail-amt">
                                        {{ formatCurrency(invoice.subtotal) }}
                                    </div>
                                    </li>
                                    <li class="price-detail d-flex justify-content-between">
                                    <div class="detail-title">
                                        Descuentos
                                    </div>
                                    <div class="detail-amt">
                                        {{ formatCurrency(invoice.discounts) }}
                                    </div>
                                    </li>
                                    <li class="price-detail d-flex justify-content-between">
                                    <div class="detail-title">
                                        Base imponible
                                    </div>
                                    <div class="detail-amt">
                                        {{ formatCurrency(invoice.taxableBase) }}
                                    </div>
                                    </li>
                                    <li v-if="applyVAT" v-for="(vat, index) in invoice.vats" :key="vat.value+'vat'"  class="price-detail d-flex justify-content-between">
                                    <div class="detail-title">
                                        IVA {{ vat.value }}%
                                    </div>
                                    <div class="detail-amt">
                                        {{ formatCurrency(vat.price) }}
                                    </div>
                                    </li>
                                    <li v-for="(pit, index) in invoice.pits" :key="pit.value+'pit'" v-if="invoice.pits && applyPIT"  class="price-detail d-flex justify-content-between">
                                    <div class="detail-title">
                                        IRPF {{ pit.value }}%
                                    </div>
                                    <div class="detail-amt">
                                        {{ formatCurrency(pit.price) }}
                                    </div>
                                    </li>
                                </ul>
                                <hr>
                                <ul class="list-unstyled">

                                    <li class="price-detail d-flex justify-content-between">
                                    <div class="detail-title">
                                        Total
                                    </div>
                                    <div class="detail-amt font-weight-bolder">
                                        {{ formatCurrency(invoice.amount) }}
                                    </div>
                                    </li>
                                </ul>
                            </div>
                        </BCol>
                    </BRow>

                <!-- Action Buttons -->
                <BButton id="submitbutton" variant="primary" class="mt-4 mb-1 mb-sm-0 mr-0 mr-sm-1" :block="$store.getters['app/currentBreakPoint'] === 'xs'" @click="onSubmit"> {{ $t("Save Changes") }} </BButton>
                <BButton variant="outline-secondary" class="mt-4" type="reset" :to="{ name:'enrollments' }" :block="$store.getters['app/currentBreakPoint'] === 'xs'"> {{$t('Cancel')}} </BButton>
            </BForm>
        </ValidationObserver>
    </BCard>
</template>

<script>
import { BButton, BMedia, BAvatar, BRow, BCol, BFormGroup, BFormInput, BForm, BTable, BCard, BCardHeader, BCardTitle, BFormCheckbox, BFormInvalidFeedback, BFormDatepicker } from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { computed, inject } from '@vue/composition-api'
import { required } from 'vee-validate/dist/rules'
import formValidation from '@core/comp-functions/forms/form-validation'
import TextInputValidated from '@/components/forms/TextInputValidated.vue'
import vSelectValidated from '@/components/forms/vSelectValidated.vue'
import NumberInputValidated from '@/components/forms/NumberInputValidated.vue'
import DatepickerValidated from '@/components/forms/DatepickerValidated.vue'
import popups from '@/hooks/popups'
import vSelect from 'vue-select'
import store from '@/store'
import CheckboxValidated from '@/components/forms/CheckboxValidated.vue'
import { watch, ref } from '@vue/composition-api';
import axios from '@axios'
import { getPaymentMethods } from '@/composables/paymentMethodService'
import { getCashes } from '@/composables/cashService'
import cash from '@/router/routes/cash'
import invoiceUtils from '@/hooks/invoiceUtils'
import currency from '@/utils/currency'

export default {
    components: { DatepickerValidated, NumberInputValidated, TextInputValidated, vSelectValidated, BButton, BMedia, BAvatar, BRow, BCol, BFormGroup, BFormInvalidFeedback, BFormInput, BForm, BTable, BCard, BCardHeader, BCardTitle, BFormCheckbox, ValidationProvider, ValidationObserver, vSelect, BFormDatepicker, CheckboxValidated },
    emit: ['changed-query'],

    setup(props, ctx) {
        const {invoice, item, getItemTaxableBase, calculateInvoice, setBankAccount, setBillingData, validateInvoice, changeToCurrentTax, updateDiscountTax, vatBeforeUpdated, pitBeforeUpdated, discountBeforeUpdated, updateItemForm, onItemInputChange, onCustomerInputChange, paymentMethodsOptions, itemsOptions, customerOptions, vatsOptions, pitsOptions, groupsOptions, cashesOptions, settings, fetchStudents, fetchAccounts, itemsSuggestions, customersSuggestions, addNewItemInItemForm, removeItem, type, updateCustomerForm, invoicePit, setCashVisibility, setTaxesVisibility, applyPIT, applyVAT, showCashes, economicActivityOptions, itemTypeOptions, fetchAccountingAccounts, accountingAccountOptions, onItemTypeInput, onAccountingInput, setEconomicActivity} = invoiceUtils()

        const { formatCurrency } = currency()
        const { getValidationState } = formValidation()
        const { errorToast } = popups()
        const students = inject('students')
        const enrollment = inject('enrollment')
        const courses = inject('courses')
        const groups = inject('groups')
        const terms = inject('terms')
        const minDateEnrollment=ref(null)
        const cursoMensual=ref(false);
        const termsToPay=ref([])
        const termsCourse=ref([])
        const studentsQuery = inject('studentsQuery')
        const coursesQuery = inject('coursesQuery')
        extend('required', required)

        const onSubmit = function() {

            this.$refs.form.validate().then(success => {
                if(success) {

                    if (enrollment.value.course.end_date && new Date(enrollment.value.course.end_date)<=new Date(Date.now())) {
                        errorToast('No puedes hacer una matrícula de un curso acabado.') 
                        return
                    }
                    document.getElementById('submitbutton').disabled=true;

                    enrollment.value.course_id=enrollment.value.course.id
                    enrollment.value.student_id=enrollment.value.student.id
                    enrollment.value.invoice=invoice.value


                    store.dispatch('enrollments/addEnrollment', enrollment.value)
                        .then(response => {
                            if (response.data.success) {
                                document.getElementById('submitbutton').disabled=false;
                                this.$router.push({ name: 'enrollments' })    
                            } else {
                                document.getElementById('submitbutton').disabled=false;
                            }
                        })
                        .catch(error => {
                            document.getElementById('submitbutton').disabled=false;

                            errorToast('Can\'t update enrollments') 
                        })
                }
            })
        }

        const changedStudentsQuery= function (val) {
            studentsQuery.value=val
            ctx.emit("changed-query")
        }

        const changedCoursesQuery= function (val) {
            coursesQuery.value=val
            ctx.emit("changed-query")
        }

        const setInvoiceData = () => {
            
            if (enrollment.value.make_invoice) {
                if (enrollment.value.student) updateCustomerForm(enrollment.value.student)
                if (enrollment.value.course) {
                    invoice.value.items = [enrollment.value.course]; 
                    enrollment.value.course.vat = enrollment.value.course.tax.value
                    invoice.value.group = enrollment.value.course.group
                    if (cursoMensual.value) {
                        let course_start_date = new Date(enrollment.value.course.start_date).toISOString()
                        if (enrollment.value.start_date >= course_start_date) {
                            invoice.value.items.push({
                                amount: enrollment.value.course.monthly_payment,
                                vat: enrollment.value.course.vat
                            })
                        }
                    } 
                }


                if (termsToPay.value.length>0) {
                    let arrayTerms = termsToPay.value.map(t => { t.amount = t.term_payment; t.vat = enrollment.value.course.vat; t.pit = null;  return t})
                    invoice.value.items.push(...arrayTerms)
                }
            }
            
            setBillingData()
            setBankAccount()
            calculateInvoice()
        }

        watch(enrollment, () => {
            if (enrollment.value.invoice) unwatch(); 

            if (enrollment.value.course) {
                termsToPay.value=[]
                termsCourse.value=[]

                if (enrollment.value.course.monthly_payment) {
                    cursoMensual.value=true;
                    minDateEnrollment.value= new Date(enrollment.value.course.start_date)
                    minDateEnrollment.value.setDate(minDateEnrollment.value.getDate()-1)
                    minDateEnrollment.value=minDateEnrollment.value.toISOString()
                } else {
                    cursoMensual.value=false;
                    terms.value.forEach(term => {

                        if (term.course_id==enrollment.value.course.id) {

                            termsCourse.value.push(term);
                            minDateEnrollment.value=new Date(termsCourse.value[0].start_date)
                            minDateEnrollment.value.setDate(minDateEnrollment.value.getDate()-1)
                            minDateEnrollment.value=minDateEnrollment.value.toISOString()
                            
                            // Terms to pay
                            if (enrollment.value.start_date) {
                                let dateNow=new Date(Date.now()).toISOString()
                                // && (term.start_date <= dateNow.substring(0, dateNow.indexOf('T')))

                                if (((term.start_date<=enrollment.value.start_date) && minDateEnrollment.value<dateNow.substring(0, dateNow.indexOf('T')))|| ((enrollment.value.start_date==term.start_date)&&(enrollment.value.start_date==dateNow.substring(0, dateNow.indexOf('T')))) ) {
                                    termsToPay.value.push(term) 
                                } 
                            }   
                        }
                    });    
                }

                if (enrollment.value.course.group_id) {
                    enrollment.value.group_id=enrollment.value.course.group_id
                }

                
                
                // enrollment.value.last_month_payment=enrollment.value.course.last_month_payment

               
            }

            setInvoiceData()

        }, {deep:true})

        watch(() => invoice.value.payment_method, () => {
            invoice.value.cash_id=''
            setBankAccount()
        })


        const changedCourse= () => {
            enrollment.value.group_id=null
            // enrollment.value.last_month_payment=enrollment.value.course.last_month_payment 
            // enrollment.value.monthly_payment=enrollment.value.course.monthly_payment
            // if (new Date(enrollment.value.start_date).getMonth()>new Date(enrollment.value.course.start_date).getMonth()  || new Date(enrollment.value.start_date).getYear()>new Date(enrollment.value.course.start_date).getYear()) {
            //         enrollment.value.first_month_payment=enrollment.value.course.monthly_payment
            //     } else {
            //         enrollment.value.first_month_payment=enrollment.value.course.first_month_payment
            //     }
        }

        const minDate = computed(() => {
            const now = new Date()
            const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
            const minDate = new Date(today)
            return minDate
        })

        return {
            getValidationState,
            onSubmit,
            minDate,
            enrollment,
            students,
            courses,
            groups,
            minDateEnrollment,
            cursoMensual,
            termsToPay,
            changedCourse, 
            changedStudentsQuery, 
            changedCoursesQuery,
            paymentMethodsOptions,
            cashesOptions,
            invoice,
            formatCurrency,
            applyPIT, 
            applyVAT
        }
    }
}
</script>

<style lang="scss">
@import '~@core/scss/vue/libs/vue-select.scss';
</style>
